
<template>
  <gj-popover
      lazy
      :trigger="trigger"
      :placement="placement"
      :open-delay="400"
      @show="pageShow = true"
  >
    <template v-if="$slots.title" class="popover-msg">
      <slot name="title"></slot>
    </template>
    <div v-else-if="title" class="popover-msg">
      <label class="popover-font">{{title}}</label>
    </div>
    <div class="wrapper" :style="{width: width}" v-if="pageShow">
      <template v-if="array">
        <div class="wrapper-in" v-for="(items, parentIndex) in data" :key="parentIndex" :class="{'border-bottom': (parentIndex + 1) !== data.length}">
          <div class="row" :style="{paddingTop: index === 0 ? '0' : ''}" v-for="(item, index) in items" :key="index"
               :class="{'column--color': index % 2 !== 0}">
            <div class="column column-label--color" :style="{fontWeight: item.bold ? 'bold': ''}">
              <gj-text width="90%">{{item.label}}</gj-text>
            </div>
            <div class="column column-value--color" :style="{textAlign: initAlign(item), fontWeight: item.bold ? 'bold': ''}">
              <gj-text width="90%">{{item.value}}</gj-text>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="wrapper-in">
          <div class="row " v-for="(item, index) in data" :key="index" :class="{'column--color': index % 2 !== 0}">
            <div class="column column-label--color" :style="{fontWeight: typeof item === 'object' && item.bold ? 'bold': '', width: '50%'}">
              <gj-text width="90%">{{item.label || item}}</gj-text>
            </div>
            <div v-if="isMeaningful(item.value)" class="column column-value--color" :style="{textAlign: initAlign(item), fontWeight: item.bold ? 'bold': '', width: '50%'}">
              <gj-text width="90%">{{item.value}}</gj-text>
            </div>
          </div>
        </div>
      </template>
    </div>
    <span slot="reference">
      <slot></slot>
      <i v-if="hasIcon" class="el-icon-arrow-down" style="transform: scale(0.75);"></i>
    </span>
  </gj-popover>
</template>

<script>
    import {isMeaningful} from "../../utils/common";

    export default {
      name: "gj-popover-panel",
      props: {
        title: {
          type: String,
          default: '',
        },
        hasIcon: {
          type: Boolean,
          default: true,
        },
        placement: {
          type: String,
          default: 'left'
        },
        width: {
          type: String,
          default: '200px'
        },
        data: {
          type: Array,
          default: () => ([])
        },
        trigger: {
          type: String,
          default: 'click',
          validator: value => ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1
        },
      },
      created() {
        if (this.data.length > 0 && this.data[0] instanceof Array) {
            this.array = true;
        }
      },
      data() {
        return {
          pageShow: false,
          array: false,
          isMeaningful: isMeaningful
        }
      },
      methods: {
        initAlign(item) {
          if (isMeaningful(item) && isMeaningful(item.value)) {
              return isNaN(item.value) ? 'left' : 'right';
          }
          return 'left';
        }
      }
    }
</script>

<style scoped lang="scss">
  /deep/ .el-popover{
    padding-right: 12px;
  }
  .wrapper {
    max-height: 346px;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-track{
      background-color: rgba($color: #000000, $alpha: 0);
    }
    // padding-right: 5px;
    .wrapper-in{
      border: 1px solid #EEEFF0;
      border-radius: 4px;
      margin-right: 3px; // 滚动条边距
    }
  }
  .row {
    display: flex;
    height: 40px;
    padding: 0 20px 0 16px;
    align-items: center;
    box-sizing: border-box;
  }
  .column {
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px;
  }
  .column-label--color {
    color: #333;
  }
  .column-value--color {
    color: #333;
  }
  .column--color {
    background: #F6F8FB;
  }
  .popover-msg {
    padding-bottom: 8px;
  }
  .popover-font {
    font-size: 13px;
    font-weight: 600;
    color: #000;
    line-height: 18px;
  }
  .border-bottom {
    margin-bottom: 10px;
  }
</style>
